var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReprocess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 39,
    height: 39,
    rx: 19.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#E4E6EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1119 17.8359C25.0832 15.4814 22.7337 13.8359 20 13.8359C16.5431 13.8359 13.7007 16.4671 13.3662 19.8359",
    stroke: "#514F55",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 17.8346H26.2667C26.4876 17.8346 26.6667 17.6555 26.6667 17.4346V16.168",
    stroke: "#514F55",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9208 23.1719C14.9496 25.5264 17.299 27.1719 20.0328 27.1719C23.4897 27.1719 26.332 24.5408 26.6665 21.1719",
    stroke: "#514F55",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0327 23.1654H13.766C13.5451 23.1654 13.366 23.3445 13.366 23.5654V24.832",
    stroke: "#514F55",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20 23.4961C21.6569 23.4961 23 22.1529 23 20.4961C23 18.8392 21.6569 17.4961 20 17.4961C18.3431 17.4961 17 18.8392 17 20.4961C17 22.1529 18.3431 23.4961 20 23.4961Z",
    stroke: "#514F55",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.3 2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 22.5C21.1048 22.5 22.0002 21.6046 22.0002 20.5C22.0002 19.3954 21.1048 18.5 20.0002 18.5C19.636 18.5 19.2944 18.5974 19.0002 18.7676C18.4024 19.1134 18.0002 19.7597 18.0002 20.5C18.0002 21.2403 18.4024 21.8866 19.0002 22.2324C19.2944 22.4026 19.636 22.5 20.0002 22.5Z",
    stroke: "#514F55",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReprocess);
export default __webpack_public_path__ + "static/media/reprocess.dca33f8620e57ea1cfaedf100459890d.svg";
export { ForwardRef as ReactComponent };